export class InfoItem {
  label: string;
  value: string|number;

  constructor(label: string, value: string|number) {
    this.label = label;
    this.value = value;
  }
}
